/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ListChecksIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="list-checks"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 6L20.5 6" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 12L20.5 12" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 18L20.5 18" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.64 9.14L5.36 10.86" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.359 10.861A7.961 7.961 0 0 1 9.361 6.059" data-tinysvg-shape="arc" data-tinysvg-arc="12.985 13.148 7.961 7.961 196.694 242.921 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.64 16.28L5.36 18" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.359 18.001A7.961 7.961 0 0 1 9.361 13.199" data-tinysvg-shape="arc" data-tinysvg-arc="12.985 20.288 7.961 7.961 196.694 242.921 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
